import React from "react";
import * as XLSX from "xlsx";
import { Button, IconDownload } from "@veneer/core";
import { useTranslation } from "react-i18next";

interface ExcelType {
  header?: any; // Specify the correct type instead of `any` (e.g., string[], ReactNode, etc.)
  rows: any[]; // Specify the array type (e.g., object[], string[][])
  fileName?: string;
}

const Exporttoexcel: React.FC<ExcelType> = ({ fileName, header, rows }) => {
  const { t } = useTranslation();
  const data = rows;
  const title = fileName || "all cases";
  const exportToExcel = () => {
    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert workbook to a downloadable Excel file
    XLSX.writeFile(workbook, `${title}.xlsx`);
  };

  return (
    <Button leadingIcon={<IconDownload />} onClick={exportToExcel}>
      {t("HPI.ExportToExcel", { defaultValue: "Export To Excel" })}
    </Button>
  );
};

export default Exporttoexcel;
